import { render } from "./EwgTooltip.vue?vue&type=template&id=a82fcd54&scoped=true"
import script from "./EwgTooltip.vue?vue&type=script&lang=ts"
export * from "./EwgTooltip.vue?vue&type=script&lang=ts"

import "./EwgTooltip.vue?vue&type=style&index=0&id=a82fcd54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a82fcd54"

export default script